import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-app-fullscreen-portal" }

import { computed, onBeforeMount, defineAsyncComponent, ref } from 'vue';
import { useRootStore } from '@/store';
import InactivityModal from '@/components/InactivityModal.vue3.vue';
import AppMenu from '@/components/layout/AppMenu.vue3.vue';
import PortalAppHeader from '@/components/portal/PortalAppHeader.vue3.vue';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue3.vue';
import { useRoute } from 'vue-router';
import { ToastServiceMethods } from 'primevue/toastservice';
import { useToast } from 'primevue/usetoast';
import { MenuItem } from 'primevue/menuitem';


export default /*@__PURE__*/_defineComponent({
  __name: 'PortalApp.vue3',
  setup(__props) {

const route = useRoute();
const rootStore = useRootStore();
const currentModal = computed(() => rootStore.state.currentModal);
const currentConfirmModal = computed(() => rootStore.state.currentConfirmModal);
const hideModal = () => rootStore.dispatch('hideModal');
const hideConfirmModal = () => rootStore.dispatch('hideConfirmModal');
const initializeToast = (toast: ToastServiceMethods) => rootStore.dispatch('initializeToast', toast);

const isFullScreenPage = computed(() => {
    return !route.matched.length || !!route.meta?.fullscreen;
});

const modals = {
    ConfirmModal: defineAsyncComponent(() => import('@/components/ConfirmModal.vue3.vue')),
    ResetLoginModal: defineAsyncComponent(() => import('@/components/staff/ResetLoginModal.vue3.vue')),
    ExtendedMessageModal: defineAsyncComponent(() => import('@/components/alerts/ExtendedMessageModal.vue3.vue')),
    InactivityModal: defineAsyncComponent(() => import('@/components/InactivityModal.vue3.vue')),
    SignatureModal: defineAsyncComponent(() => import('@/components/common/SignatureModal.vue3.vue')),
    VisitRequestConfirmationModal: defineAsyncComponent(() => import('@/components/portal/VisitRequestConfirmationModal.vue3.vue')),
    PatientClinicalNotesModal: defineAsyncComponent(() => import('@/components/portal/patient/PatientClinicalNotesModal.vue3.vue')),
    PatientContactSettingsModal: defineAsyncComponent(() => import('@/components/portal/patient/PatientContactSettingsModal.vue3.vue'))
};

const navItems = ref<MenuItem[]>([
    {
        label: 'Home',
        icon: 'pi pi-home', 
        to: '/home',
    },
    {
        label: 'Messages',
        icon: 'pi pi-envelope',
        to: '/messages'
    },
    {
        label: 'Upcoming Appointments',
        icon: 'pi pi-calendar',
        to: '/visits/upcoming'
    },
    {
        label: 'Appointment Requests',
        icon: 'pi pi-clock',
        to: '/visits/requests'
    },
    {
        label: 'Clinical Notes',
        icon: 'pi pi-file',
        to: '/visits/clinical-notes'
    }
]);

function getComponent(name: string) {
    if (!name || !(name in modals)) return;
    return modals[name as keyof typeof modals];
}

onBeforeMount(()=> {
    document.title = "Patient Portal | Net Health";
    initializeToast(useToast());
})


return (_ctx: any,_cache: any) => {
  const _component_p_toast = _resolveComponent("p-toast")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_p_toast, { position: "top-center" }),
    (!isFullScreenPage.value)
      ? (_openBlock(), _createBlock(PortalAppHeader, {
          key: 0,
          "show-profile": ""
        }))
      : _createCommentVNode("", true),
    (!isFullScreenPage.value)
      ? (_openBlock(), _createBlock(AppMenu, {
          key: 1,
          items: navItems.value
        }, null, 8, ["items"]))
      : _createCommentVNode("", true),
    _createVNode(LoadingSpinner),
    _createElementVNode("div", {
      id: "app-main-portal",
      class: _normalizeClass(["h-full", {
                'p-0': isFullScreenPage.value,
                'bg-white min-h-screen': !isFullScreenPage.value
            }])
    }, [
      _createVNode(_component_router_view)
    ], 2),
    (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(currentModal.value.name)), _mergeProps(currentModal.value.props, { onClose: hideModal }), null, 16)),
    (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(currentConfirmModal.value.name)), _mergeProps(currentConfirmModal.value.props, { onClose: hideConfirmModal }), null, 16)),
    _createVNode(InactivityModal)
  ]))
}
}

})